import { Card } from 'react-bootstrap';
import styled from 'styled-components';

export const PropertyCard = styled(Card)`
	background-color: '#c1c1c1';
`;

 